import React from 'react';

import { IORDropdown } from '../../../ior-dropdown/ior-dropdown';
import { useCustomsContext } from '../../context/context';
import type { CustomsContextValue } from '../../types';
import { CustomsField } from '../customs-field';

import messages from '../messages';

export const CustomsIOR = () => {
  const { importerOfRecord, updateImporterOfRecord }: CustomsContextValue = useCustomsContext();

  return (
    <CustomsField label={messages.iorLabel} recommended>
      <IORDropdown importerOfRecord={importerOfRecord} updateImporterOfRecord={updateImporterOfRecord} />
    </CustomsField>
  );
};
